import { render } from "./BusinessAddress.vue?vue&type=template&id=3b5e56f0&scoped=true"
import script from "./BusinessAddress.vue?vue&type=script&lang=js"
export * from "./BusinessAddress.vue?vue&type=script&lang=js"

import "./BusinessAddress.vue?vue&type=style&index=0&id=3b5e56f0&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5e56f0"]])

export default __exports__